import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Device from "react-device";
import Alert from "react-s-alert";
import Network from "react-network";
import {withRouter} from "react-router";
import "./assets/libs/md5_device_fingerprint";
// mandatory
import "react-s-alert/dist/s-alert-default.css";
import "react-s-alert/dist/s-alert-css-effects/stackslide.css";
import * as actions from "./actions";
import {APP_VERSION, FIREBASE_PROJECTID,} from "./util/constants";
import {isSafari} from "./util/browser";
import firebase from "./assets/libs/firebase";
//components
import NavigationBar from "./components/NavigationBar";
import MobileComponent from "./components/MobileComponent";
import LeftBar from "./components/LeftBar";
import Notification from "./components/Notification";
import ErrorBoundary from "./components/ErrorBoundary";
import Footer from "./components/Footer";
import AcceptAvailabilityModal from "./components/modal/AcceptAvailabilityModal";
import {
    generateUUID,
    getFirebaseToken,
    isEmpty,
    navigate,
    removeAllModalPopUps,
    requestPush,
    signInAnonymously,
    subscribeToAvailabilityCall,
    vuepayAlert,
} from "./util/utility";
import {getEncryptedIdForBroadcaster} from "./util/broadcast_util";
import {updateJWTToken} from "./util/broadcast/create";
import {getData, LOGIN} from "./util/storage";
import MoneyBlox from "./assets/libs/MoneyBlox";
import {isMobile} from "react-device-detect";
import ClearCache from "react-clear-cache";
import * as Sentry from "@sentry/react";
import CommanModal from "./components/modal/CommanModal";
import assets from "./util/assets";
import sb from "./util/sendbird";

const propTypes = {
    children: PropTypes.element,
};

let messaging = null;

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deviceInfo: {
                screen: "",
                platform: "",
                name: "",
                version: "",
                ip: "",
                id: "",
                app_version: APP_VERSION,
                device_token: "",
            },
            uuid: "",
            acceptRequestState: true,
            sessionType: null,
        };

        this.handleNetworkChange = this.handleNetworkChange.bind(this);
        this.generateUuid = this.generateUuid.bind(this);
    }

    generateUuid = async () => {
        let uuid = generateUUID();

        try {
            const storedValue = await sessionStorage.getItem("UUID");
            if (storedValue) {
                return storedValue;
            } else {
                sessionStorage.setItem("UUID", uuid);
                return uuid;
            }
        } catch (error) {
            sessionStorage.setItem("UUID", uuid);
            return uuid;
        }
    };

    handleNetworkChange = ({online}) => {
        if (!online) {
            if (window.location.href.indexOf("dashboard") === -1) {
                vuepayAlert(
                    "error",
                    "You are offline, you can use the platform when you get back online.",
                    () => {
                        window.location.href = "/dashboard";
                    }
                );
            }
        }
    };

    //set the device details on the basis of API response received
    setDeviceInfo = (deviceInfo, id, ip, deviceToken) => {
        if (deviceInfo.hasOwnProperty("browser")) {
            //pass the details as an action
            this.props.setDeviceInfo({
                screen: deviceInfo.screen,
                platform: deviceInfo.ua,
                name: deviceInfo.browser.name,
                version: deviceInfo.browser.version,
                ip: ip,
                id: id,
                app_version: APP_VERSION,
                device_token: deviceToken,
            });
        }
    };

    updateStatusOfBroadcast = (data) => {
        data && this.state.acceptRequestState && this.props.showAcceptOneToOneAvailabilityDialog(data && data);
        this.setState({
            acceptRequestState: false,
        });
    };

    componentDidMount() {
        //sign in anonymously in firebase
        signInAnonymously();
        // subscribeToAvailabilityCall(
        //   this.updateStatusOfBroadcast
        // );
        //this is to make sure user who is not logged in never see this screen
        requestPush();

        //pull the user ip address
        this.props.geoip();

        Sentry.init({
            dsn:
                "https://147064c5d29d41199f2dc80ead86276c@o127217.ingest.sentry.io/5338341",
            release: APP_VERSION,
            environment: FIREBASE_PROJECTID,
        });

        if (!isSafari()) {
            messaging = firebase.messaging();
        }
        let _this = this;
        if (messaging) {
            messaging.onMessage(function (payload) {

                if (
                    payload.hasOwnProperty("data") &&
                    payload.data.hasOwnProperty("type") &&
                    window.location.href.indexOf("/view/broadcast") === -1 &&
                    window.location.href.indexOf("/broadcaster/start/broadcast") === -1
                ) {
                    let type = payload.data.type;

                    switch (type) {
                        case 100:
                            //broadcaster approved
                            break;
                        case "1300":
                            payload &&
                            _this.props.showAcceptOneToOneAvailabilityDialog(payload);
                            break;
                        case "1400":
                            payload &&
                            _this.props.showAcceptOneToOneAvailabilityDialog(payload);
                            break;
                        case "1500":
                            _this.props.showCommonModal({
                                image: assets.awaiting_stopwatch,
                                title: payload.notification.title,
                                description: payload.notification.body,
                                action: {
                                    text: "OK",
                                    click: () => {
                                        navigate(_this.props, "broadcaster_create_broadcast");
                                        setTimeout(() => {
                                            document.querySelectorAll("#leftNavAvailability a")[0].click();
                                        }, 1000);
                                    }
                                }
                            });
                            break;
                    }
                }
            });
        }

        //TODO remove
        //this.sendBirdInit();
    }

    sendBirdInit(){
        sb.sbConnect("d5fb470d-1a07-4097-8198-7d78ff09be10",
            "820e500c56ad5d149d27df9c6bb1ad54a5bd41e4",
            (user) => {
                console.log("sbConnect >> successCallback", user);
                this.sendBirdCreateChannel();
            }, (error) => {
                console.log("sbConnect >> errorCallback", error)
            })
    }

    sendBirdCreateChannel(){
        sb.sbCreateChannel(["742a4c28-048f-422e-9e8f-d85b95a90bed","d5fb470d-1a07-4097-8198-7d78ff09be10"],
            (groupChannel) => {
                console.log("sendBirdCreateChannel >> successCallback", groupChannel)
            }, (error) => {
                console.log("sendBirdCreateChannel >> errorCallback", error)
            })
    }

    componentDidUpdate() {
        subscribeToAvailabilityCall(
            // this.props.showAcceptOneToOneAvailabilityDialog
            this.updateStatusOfBroadcast
        );
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.hasOwnProperty("geoip_payload") &&
            nextProps.geoip_payload !== null &&
            this.state.hasOwnProperty("deviceInfo")) {
            getFirebaseToken((deviceToken) => {
                this.setDeviceInfo(
                    this.state.deviceInfo,
                    this.state.uuid,
                    nextProps.geoip_payload.ip,
                    deviceToken
                );
            });
            this.props.resetGEOIP();
        }

        if (nextProps.notificationDataSuccess && nextProps.acceptAvailabilityData) {

            if (nextProps.notificationDataSuccess &&
                nextProps.acceptAvailabilityData &&
                nextProps.acceptAvailabilityData.data.notification_id
            ) {
                setTimeout(() => {
                    getData(LOGIN).then((data) => {
                        if (!isEmpty(data)) {

                            this.props.getNotificationData(
                                data.token,
                                data.api_token,
                                nextProps.acceptAvailabilityData &&
                                nextProps.acceptAvailabilityData.data.notification_id
                            );
                        }

                        this.props.resetNotificationData();
                    });
                }, 2000);
            }

        }

        if (
            nextProps.hasOwnProperty("join_broadcast") &&
            nextProps.join_broadcast.hasOwnProperty("privateBroadcastPayload") &&
            nextProps.join_broadcast.privateBroadcastPayload !== null &&
            nextProps.availability.acceptAvailabilityRequestFlag
        ) {

            if (nextProps.join_broadcast.isSuccess) {
                let sessionId =
                    nextProps.join_broadcast &&
                    nextProps.join_broadcast.privateBroadcastPayload.data.session_id;
                let tokenData =
                    nextProps.join_broadcast.privateBroadcastPayload.data.token;
                updateJWTToken(nextProps.join_broadcast.privateBroadcastPayload, () => {
                    this.props.initializeTokBox(
                        nextProps.join_broadcast.privateBroadcastPayload.data
                    );
                    const broadcastID = getEncryptedIdForBroadcaster(
                        this.props.notificationData && this.props.notificationData.hasOwnProperty("success")
                            ? this.props.notificationData.success.data.data.broadcast_id
                            : this.props.notificationData.data.broadcast_id
                    );
                    const privateBroadcastId = getEncryptedIdForBroadcaster(
                        nextProps.join_broadcast.privateBroadcastPayload.data.broadcast[0]
                            .id
                    );
                    removeAllModalPopUps();
                    this.props.history.push(
                        `/view/broadcast?session_id=${sessionId}&broadcast_id=${broadcastID}&token=${tokenData}&private_broadcast_id=${privateBroadcastId}`,
                        {
                            broadcaster:
                            nextProps.join_broadcast.privateBroadcastPayload.data
                                .broadcast[0].broadcaster,
                            sessionDetail: nextProps.join_broadcast.privateBroadcastPayload,
                            is_in_private_session: true,
                        }
                    );
                });
            } else if (nextProps.join_broadcast.isError) {
                vuepayAlert("error", nextProps.join_broadcast.payload.message);
            }
            this.props.resetJoinPrivateBroadcast();
            this.props.resetAvailabilityFlag();
        }

        if (
            nextProps.availability &&
            nextProps.availability.acceptAvailabilityRequest
        ) {

            this.setState({
                acceptRequestState: true,
            });
            this.joinAvailability();
        }

        if (
            nextProps.availability &&
            nextProps.availability.declineAvailabilityRequest
        ) {
            if (nextProps.availability.declineAvailabilityMessage && nextProps.availability.declineAvailabilityMessage.success.status_code === 200) {
                this.props.resetDeclineAvailabilityRequest();
                // vuepayAlert("success", nextProps.availability.payload.message);
                // navigate(this.props, "broadcaster_availability");
            } else {
                //if the status_code received from the server is NOT 200 means there has been some error occurred
                this.props.resetDeclineAvailabilityRequest();
                // vuepayAlert(
                //   "error",
                //   nextProps.availability.declineAvailabilityMessage.error.message
                // );
            }
            this.setState({
                acceptRequestState: true,
            });
        }
    }

    joinAvailability = () => {
        getData(LOGIN).then((data) => {
            const jsonData = {
                device: this.props.device,
            };
            if (!isEmpty(data)) {

                this.state.sessionType === "onetoone"
                    ? this.props.joinPrivateBroadcast(
                    data.token,
                    data.api_token,
                    this.props.notificationData && this.props.notificationData.hasOwnProperty("success")
                        ? this.props.notificationData &&
                        this.props.notificationData.success.data.data
                            .private_session_id
                        : this.props.notificationData.data.private_session_id,
                    jsonData
                    )
                    : this.props.joinBroadcast(
                    data.token,
                    data.api_token,
                    this.props.notificationData && this.props.notificationData.hasOwnProperty("success")
                        ? this.props.notificationData &&
                        this.props.notificationData.success.data.data.broadcast_id
                        : this.props.notificationData.data.broadcast_id,
                    jsonData
                    );
                // this.props.getBroadcasterDetail(data.token, data.api_token, this.getValueOfQueryParam())
            }
        });
        this.props.resetAvailabilityRequest();
    };

    declineAvailability = () => {
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {

                this.props.declineAvailabilityRequest(
                    data.token,
                    data.api_token,
                    this.props.notificationData && this.props.notificationData.hasOwnProperty("success")
                        ? this.props.notificationData &&
                        this.props.notificationData.success.data.data.request_id
                        : this.props.notificationData.data.request_id
                );
                // this.props.getBroadcasterDetail(data.token, data.api_token, this.getValueOfQueryParam())
            }
        });
    };

    acceptAvailability = (type) => {
        this.setState({
            sessionType: type.toString() === "1300" ? "onetoone" : "group",
        });
        getData(LOGIN).then((data) => {

            if (!isEmpty(data)) {

                this.props.acceptAvailabilityRequest(
                    data.token,
                    data.api_token,
                    this.props.notificationData && this.props.notificationData.success
                        ? this.props.notificationData.success.data.data.request_id
                        : this.props.notificationData.data.request_id
                );
                // this.props.getBroadcasterDetail(data.token, data.api_token, this.getValueOfQueryParam())
            }
        });
    };

    componentWillUnmount() {
    }

    render() {
        //this is invoked for any change happening on the browser from resize to change in internet
        const onChange = (deviceInfo) => {
            this.generateUuid().then((uuid) => {
                this.setState(
                    {
                        uuid,
                        deviceInfo,
                    },
                    () => {
                        this.setDeviceInfo(this.state.deviceInfo, uuid, "wrong_ip", "");
                        this.props.geoip();
                    }
                );
            });
        };

        return (
            <div>
                {/*necessary to capture device details*/}
                <div className="modal-overlay"></div>
                <div className="overlay" id="overlay"></div>
                <div className="overlayNotify" id="overlayNotify"></div>
                {/* <AcceptAvailabilityModal showAcceptAvailabilityReqDialog={this.props.showAcceptAvailabilityReqDialog}/> */}
                <AcceptAvailabilityModal
                    showAcceptAvailabilityReqDialog={
                        this.props.showAcceptAvailabilityReqDialog
                    }
                    hideDialog={this.props.hideAcceptOneToOneAvailabilityDialog}
                    notificationData={this.props.notificationData}
                    declineAvailabilityMessage={
                        this.props.availability &&
                        this.props.availability.declineAvailabilityRequestMessage
                    }
                    acceptAvailabilityRequestMessage={
                        this.props.availability &&
                        this.props.availability.acceptAvailabilityRequestMessage
                    }
                    declineAvailability={this.declineAvailability}
                    acceptAvailability={this.acceptAvailability}
                />


                {
                    this.props.flag.hasOwnProperty("showCommonModal") &&
                    <CommanModal isOpen={this.props.flag.showCommonModal}
                                 payload={this.props.flag.commonModalPayload}
                                 isConfirmationModal={this.props.flag.isConfirmationModal}
                                 actionArray={this.props.flag.actionArray}
                                 hideCommonModal={this.props.hideCommonModal}/>
                }

                <Device onChange={onChange}/>
                <Alert stack={{limit: 1}} timeout={5000} preserveContext/>

                {isMobile ? (
                    <div>
                        <MobileComponent/>
                    </div>
                ) : (
                    <ClearCache auto>
                        {({isLatestVersion, emptyCacheStorage}) => (
                            <div>
                                <Network
                                    onChange={this.handleNetworkChange}
                                    render={({online}) =>
                                        online ? null : (
                                            <p className="offline-status">
                                                You are offline, you can use the platform when you get
                                                back online.
                                            </p>
                                        )
                                    }
                                />

                                <NavigationBar/>
                                {this.props.leftBar.isVisible && <LeftBar/>}
                                <Notification/>
                                <ErrorBoundary>
                                    <div>{this.props.children}</div>
                                </ErrorBoundary>
                                <MoneyBlox/>
                                <Footer
                                    isLatestVersion={isLatestVersion}
                                    emptyCacheStorage={emptyCacheStorage}
                                />
                            </div>
                        )}
                    </ClearCache>
                )}
            </div>
        );
    }
}

function mapStateToProps(state, ownParams) {
    if (state.hasOwnProperty("geoip") && state.geoip.hasOwnProperty("payload")) {
        return {
            geoip_payload: state.geoip.payload,
            leftBar: state.leftBar,
            showAcceptAvailabilityReqDialog: state.availability.showAcceptAvailabilityReqDialog,
            notificationDataSuccess: state.availability.notificationDataSuccess,
            acceptAvailabilityData: state.availability.acceptAvailabilityData,
            notificationData: state.availability.notificationData,
            device: state.device.payload,
            join_broadcast: state.join_broadcast,
            availability: state.availability,
            flag: state.flag
        };
    }
    return {
        geoip_payload: null,
        leftBar: state.leftBar,
        flag: state.flag
    };
}

App.propTypes = propTypes;
export default withRouter(connect(mapStateToProps, actions)(App));
